/*
 * Takes an array of the filter keys and a URLSearchParams object to exclude
 * unwanted parameters from the API request.
 * @param {Array} filterKeys - An array of keys to keep in the URLSearchParams object.
 * @param {URLSearchParams} paramsObj - The URLSearchParams object to sanitize.
 * @returns {string} - A sanitized query string with only the specified keys.
*/

const sanitizeParams = (filterKeys, paramsObj) => {
	const paramsCopy = new URLSearchParams(paramsObj.toString());
	const formattedParams = new Map();

	paramsCopy.forEach((value, key) => {
		if (filterKeys && !filterKeys.includes(key)) return;

		if (!formattedParams.has(key)) {
			// Combine values for the same key into a comma-separated string
			const values = paramsCopy.getAll(key).join(",");
			formattedParams.set(key, values);
		}
	});

	let paramsString = "";
	formattedParams.forEach((value, key) => {
		paramsString += `${key}=${value}&`;
	});

	return paramsString.slice(0, -1);
}

export default sanitizeParams;